<template>
  <div style="
  height: calc(100vh - 55px);
width: 100%;
    display: block;
    max-width: 100%;
    overflow-wrap: break-word;
    white-space: normal;">
    <b-row style="border-bottom: 2px solid #c2c2c2">
      <b-col sm="12">
        <div class="margin-neg">
          <b-row>
            <b-col sm="2">
              <b-form-group
                  label="Rechnungsart"
              >
                <b-form-select
                    :options="queryTypeSelects"
                    v-model="queryType"
                    size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col sm="2" v-if="definition && definition.id">
              <b-form-group
                  label="Verarbeitet ?"
              >
                <b-form-select
                    :options="processedSelects"
                    v-model="processed"
                    size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col md="3" lg="3" xl="2">
              <b-row>
                <b-col md="6" style="padding: 0px">
                  <span>Abgerechnet von</span>
                  <b-row style="margin-left: 0px; margin-right: 0px">
                    <b-checkbox style="margin-top: 0.6rem" v-model="hasFrom"></b-checkbox>
                    <datetime
                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem; width: 65%;"
                        v-model="from"
                        input-class="form-control form-control-sm"
                        input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                        input-id="date1"
                        :phrases="datetimeConfig.phrases"
                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                        size="sm"
                    ></datetime>
                  </b-row>
                </b-col>
                <b-col md="6" style="padding: 0px">
                  <span>Abgerechnet bis</span>
                  <b-row style="margin-left: 0px; margin-right: 0px">
                    <b-checkbox style="margin-top: 0.6rem" v-model="hasTill"></b-checkbox>
                    <datetime
                        style="-webkit-print-color-adjust: exact !important;color-adjust: exact !important; margin-top: 0.5rem; width: 65%;"
                        v-model="till"
                        input-class="form-control form-control-sm"
                        input-style="color: black; height: auto; padding-top: 3px; padding-bottom: 3px;"
                        input-id="date"
                        :phrases="datetimeConfig.phrases"
                        :format="{ day: '2-digit', month: '2-digit', year: 'numeric'}"
                        size="sm"
                    ></datetime>
                  </b-row>

                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="!selectedItems.length" class="ml-auto" sm="2" style="padding-left: 0px">
              <b-form-group
                  label="Suchart"
              >
                <b-form-select
                    :options="searchTypeSelects"
                    v-model="searchType"
                    size="sm">
                </b-form-select>

              </b-form-group>
            </b-col>
            <b-col v-if="!selectedItems.length" sm="2" style="padding-bottom: 1rem"
                   v-on:keypress.enter="queryData">
              <b-form-input
                  style="position:absolute; bottom:1rem; left:0;"
                  v-model="search"
                  placeholder="Suche"></b-form-input>
            </b-col>
            <b-col v-if="!selectedItems.length" sm="1" style="padding-bottom: 1rem">
              <b-button style="position:absolute; bottom:1rem; left:12px;"
                        v-on:click="queryData"
                        variant="primary"
                        class="px-4 mr-3 mt-auto">Suchen
              </b-button>
            </b-col>
            <b-col v-if="selectedItems.length" class="ml-auto" sm="2" style="padding-left: 0px">
              <b-button style="position:absolute; bottom:1rem; left:12px;"
                        v-on:click="downloadApiFile"
                        variant="primary"
                        class="px-4 mr-3 mt-auto">Schnittstellendatei herunterladen
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
    <b-row style="height: calc(100% - 89px)">
      <b-col style="height: 100%; overflow: auto; padding-right: 0px">
        <b-table striped bordered hover responsive id="my-table"
                 tbody-tr-class="test"
                 :fields="billFields"
                 :items="items"
                 sticky-header
                 style="height: 100%; max-height: 100%"
                 @row-clicked="(item) => {
                   $refs.bill_overlay.showDialog(item.invoice_number);
                 }"
                 >
          <template v-slot:cell(icon)="row">
            <div v-if="definition && definition.id" @click.stop class="h-100 d-flex align-items-center justify-content-center" style="padding-left: 0.75rem; padding-top: 0.05rem">
              <b-form-checkbox size="lg"
                               v-model="row.item.selected"
                               :value="true"
                               @change="(checked) => {}"
                               :unchecked-value="false"></b-form-checkbox>
            </div>
            <!--i class="icon-clock icons font-xl d-block" v-if="row.item.offen === 0"></i-->
            <book-open-page-variant-icon v-else-if="row.item.invoice_type === 'TASK'" class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red"></book-open-page-variant-icon>
            <wallet-icon v-else class="icon-1_5x" fillColor="#ac121b" :size="72" style="color:red"></wallet-icon>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <bill-overlay ref="bill_overlay" :show-loader="showLoader" :hide-loader="hideLoader"></bill-overlay>
  </div>
</template>

<script>
import WalletIcon from 'vue-material-design-icons/Wallet.vue';
import BookOpenPageVariantIcon from 'vue-material-design-icons/BookOpenPageVariant.vue';
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {DateTime as LuxonDateTime} from "luxon";
import {decryptPositions} from "@/shared/crypto";
import BillOverlay from "@/views/calculation/bill_overlay.vue";

export default {
  name: "bills",
  components:
      {
        BookOpenPageVariantIcon,
        WalletIcon,
        BillOverlay,
      },
  data() {
    return {
      loader: undefined,
      queryType: 'A',
      queryTypeSelects: [
        {value: 'A', text: 'Alle'},
        {value: 'COLLECTION', text: 'Abrechnung nach Konto'},
        {value: 'TASK', text: 'Abrechnung nach Auftrag'},
      ],
      processedSelects: [
        {value: 'A', text: 'Alle'},
        {value: 'N', text: 'nicht verarbeitet'},
        {value: 'V', text: 'bereits verarbeitet'},
      ],
      processed: 'A',
      hasTill: true,
      hasFrom: true,
      till: LuxonDateTime.local().endOf('month').plus({ hours: -6 }).toISO(),
      from: LuxonDateTime.local().startOf('month').plus({ hours: 6 }).toISO(),
      currentMonth: LuxonDateTime.local().toISO(),
      datetimeConfig: {phrases: {ok: 'Ok', cancel: 'Abbruch'}, maxTime: LuxonDateTime.local().toISO()},
      search: '',
      searchType: 'R',
      searchTypeSelects: [
        {value: 'R', text: 'Rechnungsnummer'},
        {value: 'AN', text: 'Auftragsnummer'},
        {value: 'T', text: 'Textsuche'},
        {value: 'A', text: 'Ausgabekonto'},
        {value: 'E', text: 'Einnamekonto'},
      ],
      firstRequest: false,
      bills: [],
      definition: null,
    }
  },
  created() {
    if (this.$route.path !== '/auswertung/bills') {
      this.processed = 'N';
    }
    this.queryData();
  },
  computed: {
    billFields() {
      let fields = [
        { key: 'icon', label: '', thStyle: { width: '40px' } },
        { key: 'invoice_number', label: 'Rechnungsnr.', thStyle: { width: '60px' } },
        { key: 'create_date', label: 'Rechnungsdatum', formatter: "dateToString", thStyle: { width: '60px' } },
        { key: 'invoice_description', label: 'Auftrag/Konto'},
        { key: 'hh_aus', label: 'Ausgabekonto'},
        { key: 'hh_ein', label: 'Einnahmekonto'},
        { key: 'price', tdClass: 'text-right', label: 'Gesamtpreis', formatter: (value) => {
            let a = value.toFixed(2) + ' €';
            return a.replace(".", ",");
          }},
      ];
      if (this.definition && this.definition.id) {
        fields.push({ key: 'is_downloaded', label: 'Verarbeitet ?', formatter: (value) => {
            let res = "Ja"
            if (!value) {
              res = "Nein"
            }
            return res;
          }});
      }
      return fields;
    },
    items() {
      let res = [];
      for (let i = 0; i < this.bills.length; i++) {
        if (this.processed === 'A' || (this.bills[i].is_downloaded && this.processed === 'V') || (!this.bills[i].is_downloaded && this.processed === 'N')) {
          res.push(this.bills[i])
        }
      }
      return res;
    },
    selectedItems() {
      let res = [];
      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].selected) {
          res.push(this.items[i])
        }
      }
      return res;
    },
  },
  watch: {
    processed: function(newVal, oldVal) {
      for (let i = 0; i < this.bills.length; i++) {
        this.bills[i].selected = false;
      }
    },  
    till: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    from: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    hasFrom: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    hasTill: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
    queryType: function(newVal, oldVal) {
      if (this.firstRequest) {
        this.queryData();
      }
    },
  },
  methods: {
    downloadApiFile() {
      let invoiceNumbers = [];
      for (let i = 0; i < this.selectedItems.length; i++) {
        invoiceNumbers.push(this.selectedItems[i].invoice_number);
      }
      this.$http.post(
          Server_URL+'/auftragsbuch/calculation/generate_invoice_api',
          {
            definition_id: this.definition.id,
            invoice_numbers: invoiceNumbers
          }
      ).then((response) => {
        let filename = 'downloaded_file.txt';
        const disposition = response.headers.get('Content-Disposition');
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(disposition);
          if (matches != null && matches[1]) {
            // Remove potential surrounding quotes from the filename
            filename = matches[1].replace(/['"]/g, '');
          }
        }

        // 3. Create a blob URL from the response body
        const blob = new Blob([response.body]);
        const downloadUrl = window.URL.createObjectURL(blob);

        // 4. Create a hidden link and click it to trigger the download
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename); // Set the filename

        // Append to body, click, and clean up
        document.body.appendChild(link);
        link.click();

        // 5. Cleanup the DOM and release the object URL memory
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);

      }, (response) => {

      });
      for (let i = 0; i < this.selectedItems.length; i++) {
        this.selectedItems[i].is_downloaded = true;
      }
    },
    showLoader() {
      if (this.loader === undefined)
        this.loader = this.$loading.show();

    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    queryData() {
      this.showLoader();
      let urlPart = '' + this.queryType;
      urlPart += "?search_type=" + this.searchType + "&search=" + encodeURIComponent(this.search);
      urlPart += (this.hasFrom ? "&from=" + this.from.split('T')[0] : "") + (this.hasTill ? "&till=" + this.till.split('T')[0] : "");
      this.$http.get(
          Server_URL+'/auftragsbuch/bills/'+urlPart,
      ).then(this.responseOkGet, this.responseError)
    },
    responseOkGet(response) {
      this.hideLoader();
      this.firstRequest = true;
      if (response.status === 200 ) {
        this.bills = response.body.bills;
        this.definition = response.body.invoice_definition;
      } else {
        //window.location = Redirect_500;
        console.log(response);
      }
    },
    dateToString(value) {
      if (value === null) {
        return ""
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
    responseError(response) {
      this.hideLoader();
      console.log(response);
      if (response.status === 401) {
        //window.location = Redirect_Login;
      } else {
        //window.location = Redirect_500;
      }
    },
  }
}
</script>

<style scoped>
.margin-neg {
  background: #fbfbfb;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 1rem;
}
.form-control {
  color: black;
}

::v-deep .custom-select {
  color: black;
}

</style>
